<template>
  <div>
    <van-nav-bar title="我的团队" left-arrow @click-left="$router.back()" />
    <div class="hero">
      <div class="sum-card">
        <span class="mark"><van-icon name="friends-o" /></span>
        <div>
          <div class="num">{{ count.directCount || 0 }}</div>
          <div class="label">直推人数</div>
        </div>
      </div>
      <div class="sum-card">
        <span class="mark mark-gold"><van-icon name="share-o" /></span>
        <div>
          <div class="num">{{ count.indirectCount || 0 }}</div>
          <div class="label">间推人数</div>
        </div>
      </div>
    </div>
    <van-tabs v-model="level" @change="reload">
      <van-tab title="直推" name="1" />
      <van-tab title="间推" name="2" />
    </van-tabs>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div v-if="!loading && finished && list.length === 0" class="empty">暂无成员</div>
      <div v-for="(item, index) in list" :key="index" class="item">
        <div class="row"><span>{{ item.nickname }}</span><span>{{ item.phone }}</span></div>
        <div class="sub">累计消费 {{ money(item.consumeTotal) }} · {{ item.createTime }}</div>
      </div>
    </van-list>
  </div>
</template>

<script>
import { teamCount, listTeam, money } from '../api'

export default {
  data() {
    return { count: {}, level: '1', list: [], pageNum: 1, loading: false, finished: false }
  },
  created() {
    teamCount().then(res => { this.count = res.data || {} })
  },
  methods: {
    money,
    reload() {
      this.list = []
      this.pageNum = 1
      this.finished = false
      this.loading = true
      this.onLoad()
    },
    onLoad() {
      listTeam({ pageNum: this.pageNum, pageSize: 10, level: this.level }).then(res => {
        const rows = res.rows || []
        this.list = this.list.concat(rows)
        this.pageNum += 1
        this.loading = false
        if (this.list.length >= (res.total || 0) || rows.length === 0) this.finished = true
      }).catch(() => { this.loading = false; this.finished = true })
    }
  }
}
</script>

<style scoped>
.hero { display: flex; gap: 10px; margin: 12px; }
.sum-card { flex: 1; display: flex; align-items: center; background: #fff; border-radius: 12px; padding: 16px 14px; box-shadow: 0 6px 16px rgba(31, 111, 91, 0.08); }
.mark { width: 40px; height: 40px; border-radius: 12px; display: flex; align-items: center; justify-content: center; margin-right: 10px; background: #e7f3ef; color: #1f6f5b; font-size: 20px; flex: none; }
.mark-gold { background: #fbf1e4; color: #c47b2b; }
.label { color: #888; font-size: 13px; margin-top: 2px; }
.num { font-size: 24px; font-weight: 700; line-height: 1; }
::v-deep .van-tabs__line { background: #1f6f5b; }
::v-deep .van-tab--active { color: #1f6f5b; }
.item { background: #fff; padding: 12px 16px; border-bottom: 1px solid #f2f3f5; }
.row { display: flex; justify-content: space-between; }
.sub { color: #999; font-size: 12px; margin-top: 4px; }
.empty { text-align: center; color: #999; padding: 40px 0; }
</style>
